import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useT } from '@progress-fe/core';
import { InputNumber, Select } from '../../../../../../../../inputs';
const BlendRangeFieldFC = ({ field, isReadOnly, value, onChange }) => {
    const { t } = useT();
    if (field.options) {
        return (_jsx(Select, { name: field.name, inPortal: true, placeholder: t('common.notSelected'), options: field.options, isDisabled: isReadOnly, value: field.options.find((opt) => opt.value === value), onChange: (selected) => {
                onChange(selected.value);
            } }));
    }
    return (_jsx(InputNumber, { name: field.name, size: "xs", variant: "outline", disabled: isReadOnly, isOnChangeOnlyOnBlur: true, value: value || '', onChange: onChange }));
};
export const BlendRangeField = memo(BlendRangeFieldFC);
//# sourceMappingURL=BlendRangeField.js.map